/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantAssets } from './TenantAssets';
import {
    TenantAssetsFromJSON,
    TenantAssetsFromJSONTyped,
    TenantAssetsToJSON,
} from './TenantAssets';
import type { TenantTheme } from './TenantTheme';
import {
    TenantThemeFromJSON,
    TenantThemeFromJSONTyped,
    TenantThemeToJSON,
} from './TenantTheme';

/**
 * 
 * @export
 * @interface PortalData
 */
export interface PortalData {
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    tenant_id?: string;
    /**
     * 
     * @type {TenantAssets}
     * @memberof PortalData
     */
    assets?: TenantAssets;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    staff_title?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    name_short?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    support_email?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    company_website?: string;
    /**
     * 
     * @type {TenantTheme}
     * @memberof PortalData
     */
    theme?: TenantTheme;
    /**
     * Tenant IANA timezone — clients format tenant-local dates/times with this instead of a hardcoded zone.
     * @type {string}
     * @memberof PortalData
     */
    timezone?: string;
    /**
     * Tenant jurisdiction province — clients use this as the default for province fields instead of a hardcoded value.
     * @type {string}
     * @memberof PortalData
     */
    province?: string;
}

/**
 * Check if a given object implements the PortalData interface.
 */
export function instanceOfPortalData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortalDataFromJSON(json: any): PortalData {
    return PortalDataFromJSONTyped(json, false);
}

export function PortalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'assets': !exists(json, 'assets') ? undefined : TenantAssetsFromJSON(json['assets']),
        'staff_title': !exists(json, 'staff_title') ? undefined : json['staff_title'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'name_short': !exists(json, 'name_short') ? undefined : json['name_short'],
        'support_email': !exists(json, 'support_email') ? undefined : json['support_email'],
        'company_website': !exists(json, 'company_website') ? undefined : json['company_website'],
        'theme': !exists(json, 'theme') ? undefined : TenantThemeFromJSON(json['theme']),
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'province': !exists(json, 'province') ? undefined : json['province'],
    };
}

export function PortalDataToJSON(value?: PortalData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant_id': value.tenant_id,
        'assets': TenantAssetsToJSON(value.assets),
        'staff_title': value.staff_title,
        'name': value.name,
        'name_short': value.name_short,
        'support_email': value.support_email,
        'company_website': value.company_website,
        'theme': TenantThemeToJSON(value.theme),
        'timezone': value.timezone,
        'province': value.province,
    };
}

